import axios from 'axios';

import config from '@/config/index.js'
import store from '../store/index.js'
import router from '../router'
import Vue from 'vue'

const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'Accept-Language': store.getters.getCurrentLanguage
}

export const esc = encodeURIComponent

export function qs(params) {
  return (
    Object
    .keys(params)
    .map(k => esc(k) + '=' + esc(params[k]))
    .join('&')
  )
}


function getHeaders(custom = '') {
  let defaultHeaders = DEFAULT_HEADERS

  let access_token=store.getters.token.access
  if (access_token) {  
    defaultHeaders = {
      // 'Authorization': `Bearer ${temp_token}`,
      'Authorization': `Bearer ${access_token}`,
      ...defaultHeaders
    }
  }

  if(custom===''||custom===null){
  }
  else if(typeof custom == 'string'){
    if(custom == 'concierge_token'){
      defaultHeaders = {
        ...defaultHeaders,
        'x-api-signature': store.getters.getConciergeAuth.token,
      }
    }else if(custom == 'concierge_pin'){
      defaultHeaders = {
        ...defaultHeaders,
        'x-api-signature': store.getters.getConciergeAuth.pin
      }
    }else if(custom == 'restaurant_session'){
      if(store.getters.getRestaurantAuth.type == 'dynamic' && store.getters.getRestaurantAuth.session != ''){
        defaultHeaders = {
          ...defaultHeaders,
          'x-api-signature': store.getters.getRestaurantAuth.session
        }
      }
    }
  }
  else if(typeof custom == 'object'){
    if(custom.type == 'concierge_token_direct'){
      defaultHeaders = {
        ...defaultHeaders,
        'x-api-signature': custom.token,
      }
    }else if(custom.type == 'token_direct'){
      defaultHeaders = {
        'Authorization': `Bearer ${custom.token}`
      }
    }
  }

  return defaultHeaders
}

function getUrl(module='CORE',uri='') {
  let url = config.TICKET_BASE_API_CORE;
  if (module=='CORE'){
      url=config.TICKET_BASE_API_CORE;
  }else if(module=='BASE'){
    url=config.BASE_API
  }else if(module=='CORE_RESTO'){
    url=config.RESTO_BASE_API_CORE
  }else if(module=='CORE_HOTEL'){
    url=config.HOTEL_BASE_API_CORE
  }else if(module=='CONCIERGE'){
    url=config.CONCIERGE_BASE_API_CORE
  }else if(module=='AFFILIATE'){
    url=config.AFFILIATE_BASE_API_CORE
  }else if(module=='COMMUNITY'){
    url=config.COMMUNITY_BASE_API
  }else{
    url=module
  }
  url=url+uri;
  return url;
}

function logoutFromExpiredToken(){
  const companyType = store.getters.getCompanyType
  if(companyType == 'MERCHANT'){
    Vue.prototype.$logout();
    const useCommunityAuth = Vue.prototype.$useCommunityAuth();
    const merchantCode = store.getters.getMerchant.code
    
    let nextPath = `/${merchantCode}`
    if(!useCommunityAuth) nextPath += '/login'

    router.push(nextPath);
  }else{
    store.dispatch("logout")
    router.push('/affiliate/login');
  }
}

export function post(module,uri, data, custom_header) {
  return new Promise((resolve,reject)=>{
    axios.post(getUrl(module,uri), data, {
      headers: getHeaders(custom_header),
      withCredentials: false
      }).then(response => {
      return resolve(response);
    })
    .catch(error => {
      if (error.response.status === 401) {
        if (module == 'SIGNIN' || uri == 'auth/token') {
          return resolve(error.response);
        }else{
          if (store.getters.token.access){
            axios.post(getUrl('AUTH_REFRESH'), 
            {'refresh':store.getters.token.refresh}, {
              headers: getHeaders(custom_header)
            }).then(response_1 => {
              store.dispatch('setToken',{access:store.getters.token.access,refresh:response_1.data.access});
              axios.post(getUrl(module,uri), data, {
                headers: getHeaders(custom_header),
                withCredentials: false
              }).then(response => {
              return resolve(response);
              })
            })
            .catch(error => {
                logoutFromExpiredToken()
                return reject(new Error('USER_ANONYMOUS'))
            })
          }
          else{
              Vue.prototype.$logout();
              if (router.history.current.path != '/'+store.getters.getMerchant.code+'/login') {
                Vue.prototype.$logout();
                router.push('/'+store.getters.getMerchant.code+'/login');
                return reject(new Error('USER_ANONYMOUS'))
              }else{
                return resolve(error.response)
              }
          }
        }
      }
      else if (error.response.status === 500) {
        if (error.response.data.message=='Token has expired'){
          logoutFromExpiredToken()
          return reject(new Error('USER_ANONYMOUS'))
        }
      }
      else{
        let response=error.response
        let err = new Error(response.statusText)
        err.response = response
        return reject(err)
      }
    })
  })
}

export function get(module,uri, data = {}, custom_header) {
  uri=getUrl(module,uri);
  if (Object.keys(data).length > 0) {
    uri = `${uri}?${qs(data)}`
  }
  return new Promise((resolve,reject)=>{
    axios.get(uri, {
      headers: getHeaders(custom_header),
      withCredentials: false
    }).then(response => {
        return resolve(response);
    })
    .catch(error => {
      if(error.response){
        if (error.response.status === 401) {
          if (store.getters.token.access){
            axios.post(getUrl('AUTH_REFRESH'), 
            {'refresh':store.getters.token.refresh}, {
              headers: getHeaders(custom_header)
            }).then(response_1 => {
              store.dispatch('setToken',{access:store.getters.token.access,refresh:response_1.data.access});
              axios.get(uri, {
                headers: getHeaders(custom_header),
                withCredentials: false
              }).then(response => {
                return resolve(response);
              })
            })
            .catch(error => {
                logoutFromExpiredToken()
                return reject(new Error('USER_ANONYMOUS'))
            })
          }
          else{
            logoutFromExpiredToken()
            return reject(new Error('USER_ANONYMOUS'))
          }
        }
        else if (error.response.status === 500) {
          if (error.response.data.message=='Token has expired'){
            logoutFromExpiredToken()
            return reject(new Error('USER_ANONYMOUS'))
          }
        }
        else{
          let response=error.response
          let err = new Error(response.statusText)
          err.response = response
          return reject(err)
        }
      }else{
        return reject(error)
      }
    })
  })
}

export function put(module,uri, data, custom_header) {
  return new Promise((resolve,reject)=>{
    axios.put(getUrl(module,uri), data, {
      headers: getHeaders(custom_header),
      mode: 'cors',
    }).then(response => {
        return resolve(response);
    })
    .catch(error => {
      if (error.response.status === 401) {
        if (store.getters.token.access){
          axios.post(getUrl('AUTH_REFRESH'), 
          {'refresh':store.getters.token.refresh}, {
            headers: getHeaders(custom_header)
          }).then(response_1 => {
            store.dispatch('setToken',{access:store.getters.token.access,refresh:response_1.data.access});
            axios.put(getUrl(module,uri), data, {
              headers: getHeaders(custom_header),
              withCredentials: false
            }).then(response => {
                return resolve(response);
            })
          })
          .catch(error => {
            logoutFromExpiredToken()
            return reject(new Error('USER_ANONYMOUS'))
          })
        }
        else{
          logoutFromExpiredToken()
          return reject(new Error('USER_ANONYMOUS'))
        }
      }
      else if (error.response.status === 500) {
        if (error.response.data.message=='Token has expired'){
          logoutFromExpiredToken()
          return reject(new Error('USER_ANONYMOUS'))
        }
      }
      else {
      let response=error.response
      let err = new Error(response.statusText)
      err.response = response
      return reject(err)
      }
    })
  })
}

export function remove(module,uri,datas, custom_header) {
  return new Promise((resolve,reject)=>{
    axios.delete(getUrl(module,uri), {
      headers: getHeaders(custom_header),
      data:datas,
      withCredentials: false
    }).then(response => {
      return resolve(response);
    })
    .catch(error => {
      if (error.response.status === 401) {
        if (store.getters.token.access){
          axios.post(getUrl('AUTH_REFRESH'), 
          {'refresh':store.getters.token.refresh}, {
            headers: getHeaders(custom_header)
          }).then(response_1 => {
            store.dispatch('setToken',{access:store.getters.token.access,refresh:response_1.data.access});
            axios.delete(getUrl(module,uri), {
            headers: getHeaders(custom_header),
            data:datas,
            withCredentials: false
            }).then(response => {
                return resolve(response);
            })
          })
          .catch(error => {
              logoutFromExpiredToken()
              return reject(new Error('USER_ANONYMOUS'))
          })
        }
        else{
          logoutFromExpiredToken()
          return reject(new Error('USER_ANONYMOUS'))
        }
      }
      else if (error.response.status === 500) {
        if (error.response.data.message=='Token has expired'){
          logoutFromExpiredToken()
          return reject(new Error('USER_ANONYMOUS'))
        }
      }
      else{
        let response=error.response
        let err = new Error(response.statusText)
        err.response = response
        return reject(err)
      }
    })
  })
}

export function upload(module,uri, data) {
  return new Promise((resolve,reject)=>{
    fetch(getUrl(module,uri), {
      headers: getHeaders(true),
      method: 'POST',
      body: data
    })
    .then(response => {
      return resolve(response);  
    })
    .catch(error => {
      if (error.response.status === 401) {
        if (store.getters.token.access){
          axios.post(getUrl('AUTH_REFRESH'), 
          {'refresh':store.getters.token.refresh}, {
            headers: getHeaders()
          }).then(response_1 => {
            store.dispatch('setToken',{access:store.getters.token.access,refresh:response_1.data.access});
            fetch(getUrl(module,uri), {
              headers: getHeaders(true),
              method: 'POST',
              body: data
            }).then(response => {
                return resolve(response);
            })
          })
          .catch(error => {
              logoutFromExpiredToken()
              return reject(new Error('USER_ANONYMOUS'))
          })
        }
        else{
          logoutFromExpiredToken()
          return reject(new Error('USER_ANONYMOUS'))
        }
      }
      else if (error.response.status === 500) {
        if (error.response.data.message=='Token has expired'){
          logoutFromExpiredToken()
          return reject(new Error('USER_ANONYMOUS'))
        }
      }
      else{
        let response=error.response
        let err = new Error(response.statusText)
        err.response = response
        return reject(err)
      }
    })
  })
}

export function update_upload(module,uri, data) {
  return new Promise((resolve,reject)=>{
    fetch(getUrl(module,uri), {
      headers: getHeaders(true),
      method: 'PUT',
      body: data
    })
    .then(response => {
      return resolve(response);  
    })
    .catch(error => {
      if (error.response.status === 401) {
        if (store.getters.token.access){
          axios.post(getUrl('AUTH_REFRESH'), 
          {'refresh':store.getters.token.refresh}, {
            headers: getHeaders()
          }).then(response_1 => {
            store.dispatch('setToken',{access:store.getters.token.access,refresh:response_1.data.access});
            fetch(getUrl(module,uri), {
              headers: getHeaders(true),
              method: 'PUT',
              body: data
            }).then(response => {
                return resolve(response);
            })
          })
          .catch(error => {
              logoutFromExpiredToken()
              return reject(new Error('USER_ANONYMOUS'))
          })
        }
        else{
          logoutFromExpiredToken()
          return reject(new Error('USER_ANONYMOUS'))
        }
      }
      else if (error.response.status === 500) {
        if (error.response.data.message=='Token has expired'){
          logoutFromExpiredToken()
          return reject(new Error('USER_ANONYMOUS'))
        }
      }
      else{
        let response=error.response
        let err = new Error(response.statusText)
        err.response = response
        return reject(err)
      }
    })
  })
}


// WEBPACK FOOTER //
// ./src/services/index.js